import { pluralize } from "../../utils/pluralize"
import lunr, { Index } from "lunr"
require("lunr-languages/lunr.stemmer.support")(lunr)
require("lunr-languages/lunr.multi")(lunr)
require("lunr-languages/lunr.ru")(lunr)

export function mapToPost(edge) {

  const { frontmatter: { cover, lead, title, excerpt, path, mark }, timeToRead, html } = edge.node
  const imageSm = cover && cover.childImageSharp.sm
  const imageMob = cover && cover.childImageSharp.mob
  const imageLead = lead && lead.childImageSharp.fixed

  return {
    title,
    imageSm,
    imageMob,
    mark,
    imageLead,
    html,
    timeToRead,
    excerpt,
    path: `/knowledgebase/post${path}`,
  }
}


export function formatTimeToRead(timeToRead) {
  return `${timeToRead} ${pluralize(timeToRead, "минута", "минуты", "минут")} для чтения`
}

export function initSearch(index, store) {
  const idx = Index.load(index)
  return (query) => idx.search(query).map(({ ref }) => {
    return {
      path: ref,
      node: {
        ...store[ref]
      }
    }
  })
}